<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  appName?: string
}>()

const title = computed(() => (props.appName ? `Loading ${props.appName}...` : 'Loading...'))
</script>

<template>
  <v-container class="loading-container" fluid>
    <v-row class="fill-height" align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-progress-circular indeterminate size="64" color="primary" />
        <div class="loading-text">{{ title }}</div>
        <div class="loading-subtext">Please wait while we load the application.</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.loading-container {
  height: 100vh;
}

.loading-text {
  margin-top: 24px;
  color: #000000de;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
}

.loading-subtext {
  margin-top: 8px;
  color: #000000de;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.025em;
}
</style>
